<div id="kt_app_footer" class="app-footer">
  <div class="p-7 footer-section">
    <div class="left-content">
      <span>© 2025 WEGESTU. Tous droits réservés.</span>
    </div>
    <div class="right-content">
      <ul class="menu">
        <div class="footer-link">
          <li class="menu-item">
            <a href={{env.mention_legal_link}} target="_blank">Mentions légales</a>
          </li>
          <li class="menu-item">
            <a href={{env.cgu_link}} target="_blank">CGU ENTREPRISE</a>
          </li>
           <li class="menu-item">
            <a href={{env.cgv_link}} target="_blank">CGV</a>
          </li>
        </div>
        <div class="footer-link">
          <li class="menu-item">
            <a href={{env.confidential_policy_link}} target="_blank">Politique de confidentialité</a>
          </li>
        </div>
        <div class="footer-link">
          <li class="menu-item">
            <a href="https://www.linkedin.com/company/we-gest-u/?originalSubdomain=fr" target="_blank"><i
                class="fa-brands fa-linkedin"></i></a>
          </li>
          <li class="menu-item">
            <a href="https://www.facebook.com/wegestu/" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
          </li>
          <li class="menu-item">
            <a href="https://www.instagram.com/wegestu/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
          </li>
        </div>
      </ul>
        <button class="help-btn" (click)="openEmail()">Contacter WeGestU</button>
    </div>
  </div>
</div>